import type { RaffleItem } from "../types";

/**
 * Raffle objects and a time, sort into time-based buckets
 */
const raffleSort = (raffles: RaffleItem[]) => {
  const now = new Date();

  return raffles.reduce<{
    past: RaffleItem[];
    future: RaffleItem[];
    current: RaffleItem | null;
  }>(
    (acc, cur) => {
      if (cur.endDate < now) {
        // Raffle is over: start < end < now
        acc.past.push(cur);
      } else if (cur.startDate <= now) {
        // Raffle is currently happening: start <= now < end
        acc.current = cur;
      } else {
        // Raffle is yet to begin: now < start < end
        acc.future.push(cur);
      }

      return acc;
    },
    { past: [], future: [], current: null }
  );
};

export { raffleSort };
